import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { trackRequestMetrics } from './trackRequestMetrics';

// Calls the resume-match backend.
// Deployed: same-origin blue-layer route `POST /jobs/resume-match` → careers_pegasus.
// Local dev: no blue layer, so hit pegasus directly (careers_pegasus enables dev-only CORS).
const getResumeMatchUrl = () =>
    typeof window !== 'undefined' && window.location.hostname === 'localhost'
        ? 'http://localhost:9019/api/v1/resume-match'
        : pathfinder('careers_resume_match');

export interface CandidateSummary {
    fullName: string | null;
    role: string | null;
    yearsOfExperience: number | null;
    topSkills: string[];
}

export interface RankedPosition {
    id: string;
    score: number;
    reasons: string[];
}

export interface ResumeMatchResult {
    /** False when the uploaded document is not a resume/CV (org chart, article, JD, …). */
    isResume: boolean;
    candidateSummary: CandidateSummary;
    rankedPositions: RankedPosition[];
}

/** Non-200 from the resume-match backend. `status` is undefined on network-level failures. */
export class ResumeMatchHttpError extends Error {
    constructor(public readonly status?: number) {
        super(`Resume match request failed${status ? ` (${status})` : ''}`);
        this.name = 'ResumeMatchHttpError';
    }
}

export async function matchResume(stringifiedCv: string, turnstileToken?: string | null): Promise<ResumeMatchResult> {
    try {
        const { data } = await trackRequestMetrics(
            axios.post<ResumeMatchResult>(getResumeMatchUrl(), {
                stringifiedCv,
                turnstile_token: turnstileToken ?? undefined,
            }),
            'resume_match'
        );
        return data;
    } catch (err) {
        throw new ResumeMatchHttpError(axios.isAxiosError(err) ? err.response?.status : undefined);
    }
}
